// extracted by mini-css-extract-plugin
module.exports = {"pagination":"Pagination_pagination__O7JWM","flex":"Pagination_flex__W12MW","item":"Pagination_item__WqX9D","activePag":"Pagination_activePag__pQqN4"};